// @ts-expect-error untyped import
import Application from './app';
new Application().init();